import { render, staticRenderFns } from "./RegisterCustomer.vue?vue&type=template&id=9d2d85f2"
import script from "./RegisterCustomer.vue?vue&type=script&lang=js"
export * from "./RegisterCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports